import {UIMSceneEnum} from '../../../../../../shared/enums/UIMSceneEnums.ts'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables.ts'
import {type UIMSceneController} from '../../UIMSceneController.ts'
import {setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIMNavigationController {
    private readonly navigationContainer: HTMLDivElement
    private readonly animatedSlider: HTMLDivElement

    private readonly rankingTab: HTMLDivElement
    private readonly lobbyTab: HTMLDivElement
    private readonly playTab: HTMLDivElement
    private readonly storeTab: HTMLDivElement
    private readonly moreTab: HTMLDivElement

    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        this.navigationContainer = document.getElementById('bottom-nav-container') as HTMLDivElement
        this.animatedSlider = document.getElementById('bottom-nav-animated-slider') as HTMLDivElement

        this.rankingTab = document.getElementById('bottom-nav-ranking-tab') as HTMLDivElement
        this.lobbyTab = document.getElementById('bottom-nav-lobby-tab') as HTMLDivElement
        this.playTab = document.getElementById('bottom-nav-play-tab') as HTMLDivElement
        this.storeTab = document.getElementById('bottom-nav-store-tab') as HTMLDivElement
        this.moreTab = document.getElementById('bottom-nav-more-tab') as HTMLDivElement

        this.sceneController = sceneController

        this.slideToTab()
        this.handleStoreFeatureHide()
        this.moveSliderTo(this.sceneController.scene ?? UIMSceneEnum.Homepage)
    }

    private slideToTab() {
        setElementOnClick(this.rankingTab, () => this.sceneController.loadScene(UIMSceneEnum.Leaderboard))
        setElementOnClick(this.lobbyTab, () => this.sceneController.loadScene(UIMSceneEnum.Lobby))
        setElementOnClick(this.playTab, () => this.sceneController.loadScene(UIMSceneEnum.Homepage))
        setElementOnClick(this.storeTab, () => this.sceneController.loadScene(UIMSceneEnum.Store))
        setElementOnClick(this.moreTab, () => this.sceneController.loadScene(UIMSceneEnum.More))
    }

    moveSliderTo(tab: UIMSceneEnum) {
        const leftPosition = UIMNavigationController.calculateSliderPosition(tab)
        this.animatedSlider.style.left = `${leftPosition}%`
        this.animatedSlider.classList.remove('hidden')
        this.updateSelectedTab(tab)
    }

    deselectAllTabs() {
        this.rankingTab.classList.remove('selected')
        this.lobbyTab.classList.remove('selected')
        this.playTab.classList.remove('selected')
        this.storeTab.classList.remove('selected')
        this.moreTab.classList.remove('selected')
        this.navigationContainer.classList.remove('tab-0-selected', 'tab-1-selected', 'tab-2-selected', 'tab-3-selected', 'tab-4-selected')
        this.navigationContainer.classList.add('no-tab-selected')
        this.animatedSlider.classList.add('hidden')
    }

    private static calculateSliderPosition(tab: UIMSceneEnum): number {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile

        const unselectedTabWidth = 1
        const selectedTabWidth = 1.7

        const tabCount = isStoreHidden ? 4 : 5
        const totalTabsWidth = (tabCount - 1) * unselectedTabWidth + selectedTabWidth
        const step = (unselectedTabWidth / totalTabsWidth) * 100

        const updatedTab = (isStoreHidden && tab == UIMSceneEnum.More) ? tab - 1 : tab
        return updatedTab * step
    }

    private updateSelectedTab(selectedScene: UIMSceneEnum) {
        this.navigationContainer.classList.remove('no-tab-selected')
        this.rankingTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Leaderboard)
        this.lobbyTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Lobby)
        this.playTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Homepage)
        this.storeTab.classList.toggle('selected', selectedScene == UIMSceneEnum.Store)
        this.moreTab.classList.toggle('selected', selectedScene == UIMSceneEnum.More)
        this.updateTabSizing(selectedScene)
    }

    private updateTabSizing(selectedScene: UIMSceneEnum) {
        this.navigationContainer.classList.remove('tab-0-selected', 'tab-1-selected', 'tab-2-selected', 'tab-3-selected', 'tab-4-selected')
        this.navigationContainer.classList.add(`tab-${selectedScene}-selected`)
    }

    hide() {
        this.navigationContainer.style.display = 'none'
    }

    show() {
        this.navigationContainer.style.display = 'grid'
    }

    handleStoreFeatureHide() {
        if(UIUtilsEjsVariables.shouldHideStoreOnMobile != true) return
        this.navigationContainer.classList.add('store-hidden')
        this.storeTab.classList.add('hidden')
    }
}
